
    export default {
        name: "HappyKidsInsurerCardsSection",
        props: {
            anchorLink: {
                type: String,
                default: '#'
            },
            data: {
                type: Object,
                default: () => ({})
            },
            containerClass: {
              type: String,
              default: '',
            }
        },
        data() {
            return {
                windowWidth: 0,
                isActive: false,
            }
        },
        computed: {
            btnIconBackground() {
                const style = {
                    'background-image': `url(${require('@/assets/images/common/circle-red-arrow.svg')})`,
                }
                return style
            },
            getContainerClass() {
              return this.containerClass;
            }
        },
        mounted() {
            this.updateScreenWidth();
            this.onScreenResize();
        },
        methods: {
            toggleDescription() {
                this.isActive = !this.isActive;
            },
            onScreenResize() {
                window.addEventListener("resize", () => {
                    this.updateScreenWidth();
                });
            },
            updateScreenWidth() {
                this.windowWidth = window.innerWidth;
            },
            iconSrc(icon) {
                return require(`@/assets/images/family/icon/${icon}.png`)
            }
        },
    }
